export default __webpack_public_path__ + "static/media/reward.9e69640b.svg";